import axios from './axios'


class Paging {

  page
  limit
  url
  params = {}
  total = 0
  loadingStatus = false
  currentPageData = []


  constructor(url, page = 1,limit = 10) {
    this.page = page
    this.limit = limit
    this.url = url
  }

  setOtherParams(data) {

    this.params = data

  }

  async getPageData(page) {
    if (page) {
      this.page = page
    }

    //设置参数
    this.params.page = this.page;
    this.params.limit = this.limit
    // this.loadingStatus = true
    const res = await axios.get(this.url,{"params":{...this.params}}).then().catch((e) =>{
      console.log(e)
    })

    this.loadingStatus = false
    const result = res.data
    if(!result || !result.data){
      this.total = 0
      this.currentPageData = []
    }
    this.currentPageData = result.data
    if (result.page_info) {
      this.total = result.page_info.total
    } else {
      this.total = this.currentPageData.length
    }
  }


  setPage(page) {
    this.page = page
  }

}

export {
  Paging
}
